import styled from 'styled-components';

import { position, rem } from '../../core';

export const ToastListStyled = styled.div.attrs({
  className: 'component__toastList',
})`
  max-width: ${rem(333)};
  margin-left: 1rem;
  ${position('fixed', '1rem', '1rem', '', '')};
  z-index: 99999;
`;
